import { HeaderCell as ComposedHeaderCell, HeaderRow as ComposedHeaderRow } from "@table-library/react-table-library/table";
import React, { useContext } from "react";
import BaseCheckbox from "../../../Input/Checkbox/components/BaseCheckbox";
import { SelectContext } from "../../contexts/SelectContext";
import { getHeaderCheckboxState } from "../../logic";
import { resizerTheme } from "../../styles/BaseTable.styles";
import HeaderCell from "../Cells/Header";
import { SortableHeaderCell } from "../Cells/SortableHeader";
import { toggle } from "./logic";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function HeaderRow(_ref) {
  var columns = _ref.columns,
    tableStatus = _ref.tableStatus,
    tablePagination = _ref.tablePagination,
    data = _ref.data;
  var _useContext = useContext(SelectContext),
    selectLogic = _useContext.selectLogic,
    selectableRows = _useContext.selectableRows;
  return /*#__PURE__*/_jsxs(ComposedHeaderRow, {
    children: [selectableRows && /*#__PURE__*/_jsx(ComposedHeaderCell, {
      children: /*#__PURE__*/_jsx(BaseCheckbox, {
        disabled: Boolean(tableStatus),
        checked: getHeaderCheckboxState(selectLogic),
        onCheckedChange: function onCheckedChange() {
          return toggle(selectLogic, tablePagination, data);
        }
      })
    }), columns.map(function (_ref2) {
      var label = _ref2.label,
        resize = _ref2.resize,
        minWidth = _ref2.minWidth,
        cellType = _ref2.cellType,
        colId = _ref2.colId,
        sortable = _ref2.sortable;
      return sortable ? /*#__PURE__*/_jsx(SortableHeaderCell, {
        sortKey: colId.toUpperCase(),
        resize: resize && resizerTheme(minWidth),
        select: selectableRows ? selectLogic : null,
        children: /*#__PURE__*/_jsx(HeaderCell, {
          cellType: cellType,
          label: label
        })
      }, colId.toUpperCase()) : /*#__PURE__*/_jsx(ComposedHeaderCell, {
        resize: resize && resizerTheme(minWidth),
        select: selectableRows ? selectLogic : null,
        children: /*#__PURE__*/_jsx(HeaderCell, {
          cellType: cellType,
          label: label
        })
      }, colId.toUpperCase());
    })]
  });
}
export default HeaderRow;